import React, { Fragment, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const VipNewebpay = ({ record }) => {
  const formRef = useRef(undefined);
  useEffect(() => {
    formRef.current.submit();
  }, []);

  return (
    <Fragment>
    <div><br /><br /><center><img src="/p/image/e_3.png" /><br /><br /><h4>付款頁面轉跳中，請稍候...</h4></center></div>
    <form ref={formRef} method="POST" action={`${record.newebpay_site}MPG/mpg_gateway`}>
      <input type="hidden" name="MerchantID" value={record.MerchantID} readonly /><br />
      <input type="hidden" name="Version" value={record.Version} readonly /><br />
      <input type="hidden" name="TradeInfo" value={record.TradeInfo} readonly /><br />
      <input type="hidden" name="TradeSha" value={record.TradeSha} readonly /><br />
    </form>
    </Fragment>
  );
};

VipNewebpay.propTypes = {
  record: PropTypes.object.isRequired,
};

export default VipNewebpay;
